import { Component, OnInit, signal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { faList, faCheckCircle, faPrint } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { SessionStorageService } from '../core/services/session-storage.service';
import { GettingStartedService } from '../core/services/getting-started.service';

@Component({
  selector: 'wf-getting-started',
  standalone: true,
  imports: [FontAwesomeModule, RouterLink],
  templateUrl: './getting-started.component.html',
  styleUrl: './getting-started.component.css'
})
export class GettingStartedComponent implements OnInit {
  pageHeaderIcon = faList;
  checkIcon = faCheckCircle;
  uncheckedIcon = faCircle;
  printIcon = faPrint;

  checkedItems = signal<Set<number>>(new Set<number>());

  constructor(
    private sessionStorageService: SessionStorageService,
    private gettingStartedService: GettingStartedService
  ) {}

  ngOnInit(): void {
    const stored = this.sessionStorageService.getGettingStartedCheckedItems();
    this.checkedItems.set(new Set(stored));
  }

  isChecked(index: number): boolean {
    return this.checkedItems().has(index);
  }

  toggleItem(index: number): void {
    const checking = !this.checkedItems().has(index);
    const call = checking
      ? this.gettingStartedService.checkItem(index)
      : this.gettingStartedService.uncheckItem(index);

    call.subscribe({
      next: (updatedItems: number[]) => {
        this.checkedItems.set(new Set(updatedItems));
        this.sessionStorageService.setGettingStartedCheckedItems(updatedItems);
      }
    });
  }

  print(): void {
    window.print();
  }
}
